import { Button } from 'antd';
import { Download, Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { buildDriverColumns } from '../components/build-driver-columns';
import { CreateDriverDrawer } from '../components/CreateDriverDrawer';
import { DriversTable } from '../components/DriversTable';
import { PAYROLL_BALANCES_CSV_URL } from '../drivers.api';
import { useDriverPermissions } from '../hooks/use-driver-permissions';
import { useDrivers } from '../hooks/use-drivers';
import { sectionTrail } from '../../../shared/components/section-trail';

export function DriversPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useDrivers();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { canExportPayroll } = useDriverPermissions();

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildDriverColumns({ list });

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('drivers')}
        title="Drivers"
        description="The people who drive for you — profiles, licences and compliance documents."
        actions={
          <div className="flex items-center gap-3">
            {canExportPayroll && (
              <Button href={PAYROLL_BALANCES_CSV_URL} icon={<Download className="size-4" />}>
                Export balances
              </Button>
            )}
            <Button
              type="primary"
              icon={<Plus className="size-4" />}
              onClick={() => {
                resetCreateError();
                setDrawerOpen(true);
              }}
            >
              Create driver
            </Button>
          </div>
        }
      />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load drivers" description="Something went wrong loading the drivers list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading drivers" withSearch />}
      {state.status === 'loaded' && <DriversTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateDriverDrawer open={drawerOpen} error={createError} submitting={creating} onCreate={create} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
